<template>
  <div>
    <div class="container mt-10 mb-10">
      <h2 class="text-center">Jabrutouch es para todos</h2>
      <h6 class="text-center d-none d-sm-block">Jabrutouch está diseñado para ser útil a todo yehudí de cualquier condición, sin importar sus conocimientos previos de Talmud. Tanto si es tu primer contacto como si quieres profundizar o preparar un shiur, Jabrutouch es para ti.</h6>
      <p class="text-center d-sm-none d-block">Jabrutouch está diseñado para ser útil a todo yehudí de cualquier condición, sin importar sus conocimientos previos de Talmud. Tanto si es tu primer contacto como si quieres profundizar o preparar un shiur, Jabrutouch es para ti.</p>

      <ul class="nav nav-tabs mt-5 nav-fill" id="myTab" role="tablist">
        <li class="nav-item" role="presentation" v-for="(user, index) in users">
          <a
            class="nav-link flex-fill"
            data-toggle="tab"
            :aria-selected="index == 0"
            :href="'#tab-'+index"
            :class="[index == 0? 'active':'']"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >{{user.title}}</a>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">
        <div v-for="(user, index) in users" class="tab-pane" :id="'tab-' + index" role="tabpanel" aria-labelledby="home-tab" :class="[index == 0? 'active':'']">
          <h3 class="mb-5 text-center">{{user.header}}</h3>
          <div class="row">
            <div class="col-md">
                <img :src="require('../assets/images/'+user.img)" class="img-fluid mb-3">
            </div>
            <div class="col-md" v-html="user.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [
        {
          title: 'Bajur Yeshiva',
          header: 'Bajurei Yeshiva',
          text: '<p>Si estudias en una yeshivá, podrás preparar o repasar una Suguiá con Jabrutouch. Además, a través de la app puedes estrechar lazos con tus amigos y familiares.</p><p>¿No logras disfrutar del estudio? Habla por videoconferencia con uno de nuestros Coachers especializados para poner en marcha un seguimiento personalizado que te ayude a disfrutar del Talmud.</p>',
          img: 'chroma 2.jpg',
        },
        {
          title: 'Profesional o comerciante',
          header: 'Profesionales y comerciantes',
          text: '<p>Estudiar Talmud es perfectamente compatible con cualquier profesión y horario. Jabrutouch te permite descubrir o profundizar en el mayor tesoro judío sin desatender tus obligaciones laborales. Además, la app está diseñada para que puedas controlar tu progreso de estudio. ¡Tú decides hasta dónde quieres llegar!</p>',
          img: 'shutterstock_1563129436.jpg',
        },
        {
          title: 'Estudiantes',
          header: 'Estudiantes de colegio',
          text: '<p>Con Jabrutouch tienes la oportunidad de conocer el Talmud, descubrir el placer de estudiarlo y desarrollar tu intelecto hasta cotas asombrosas.</p><p>Además, la nueva versión de la app te permite buscar shiurim según tus temas de interés y localizar el texto y minuto exacto donde el Talmud habla o discute sobre ellos.</p>',
          img: 'estudiante2 1.jpg',
        },
        {
          title: 'Universitario',
          header: 'Estudiantes universitarios',
          text: '<p>Para una etapa tan absorbente como la universitaria, Jabrutouch es tu mejor aliado para acercarte al Talmud y estudiar de forma autodidacta cuando quieras y como quieras.</p><p>Con la función de Concordatsia podrás localizar en el Talmud cualquier tema que te interese y descubrir una perspectiva totalmente distinta capaz de enriquecer tus conocimientos académicos.</p>',
          img: 'universitario.jpg',
        },
        {
          title: 'Avrej',
          header: 'Avrejim y Rabanim',
          text: '<p>Jabrutouch te facilita:</p><ul><li>Preparar tus shiurim.</li><li>Repasar e interiorizar más las suguiot estudiadas.</li><li>Enseñar a Baale Batim a impartir shiurim.</li><li>Convertirte en Coach o dominar un Masejet para responder a tus Talmidim.</li></ul>',
          img: 'shutterstock_105293906.jpg',
        },
        {
          title: 'Senior',
          header: 'Adultos mayores',
          text: '<p>Si piensas que ya no tienes edad para estudiar y mucho menos el Talmud, te equivocas. Nunca es tarde.</p><p>Jabrutouch te hará recobrar la ilusión de adentrarte en el estudio del Talmud gracias a una plataforma móvil sencilla y amigable.</p>',
          img: '1671652690-huge.jpg',
        },
      ]
    }
  },
}
</script>
<style lang="scss" scoped>
.tab-content{
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 20px 20px;
  padding: 3rem;
  border: 1px solid #dee2e6;
  border-top: 0;
}
.nav-tabs .nav-link {
   background: #94CDF0;
  color: black;
}
</style>